import React, { useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import "./FAQCard.css";

export default function FAQList({ data,title }) {
    return (
        <div className='faq-wrapper'>
            {title && <h2 className="faq-title testimonials-title">{title}</h2>}
            <br/>
            {data.map((item, index) => (
                <FAQCard key={index} data={item} />
            ))}
        </div>
    );
}

function FAQCard({title, data }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="faq-card">
            {/* Header */}
            <button
                type="button"
                onClick={() => setIsOpen((prev) => !prev)}
                className="faq-card-header"
            >
                <h2 className="faq-card-question">{data.question}</h2>

                <div className="faq-card-icon-wrapper">
                    <FaPlus
                        className={`faq-card-icon ${!isOpen ? "faq-card-show" : "faq-card-hide"}`}
                    />
                    <FaMinus
                        className={`faq-card-icon ${isOpen ? "faq-card-show" : "faq-card-hide"}`}
                    />
                </div>
            </button>

            {/* Content */}
            <div className={`faq-card-answer-wrapper ${isOpen ? "faq-card-open" : "faq-card-closed"}`}>
                {data.content?.map((block, index) => {
                    switch (block.type) {
                        case "answer":
                            return (
                                <div
                                    key={index}
                                    className="faq-card-answer"
                                    dangerouslySetInnerHTML={{ __html: block.text }}
                                />
                            );

                        case "list":
                            return (
                                <ul key={index} className="faq-card-list">
                                    {block.items.map((item, i) => (
                                        <li
                                            key={i}
                                            className="faq-card-list-item"
                                            dangerouslySetInnerHTML={{ __html: item }}
                                        />
                                    ))}
                                </ul>
                            );

                        case "note":
                            return (
                                <div
                                    key={index}
                                    className="faq-card-note"
                                    dangerouslySetInnerHTML={{ __html: block.text }}
                                />
                            );

                        default:
                            return null;
                    }
                })}
            </div>
        </div>
    );
}
